module.exports = __webpack_public_path__ + "assets/Retina-Thin.76b81bd49c475982644a2fabf9067bf0.woff2";